export const AutomationTemplateFragment = gql`
  fragment AutomationTemplateFragment on AutomationTemplate {
    id
    actions {
      ...AutomationActionTemplateFragment
    }
    configurationPromptForAI
    triggerType
    triggerInspectionResults {
      ...InspectionResultFragment
    }
    wasConfiguredWithAi
  }
  fragment AutomationActionTemplateFragment on AutomationActionTemplate {
    id
    addRecordTaskTemplateGroupId
    beginWorkflowTemplateId
    changeToStatus {
      ...RecordTypeStatusFragment
    }
    conditions {
      ...AutomationActionTemplateConditionFragment
    }
    delay {
      ...DateTemplateFragment
    }
    emailApplicant
    emailOwner
    emailSubmitter
    emailTemplate {
      ...EmailTemplateFragment
    }
    id
    isExpiration
    feeTemplate {
      id
    }
    recipients {
      id
      emailAddress
      user {
        ...UserDataFragment
      }
    }
    requiredContexts {
      ...AutomationActionTemplateRequiredContextFragment
    }
    type
  }
  fragment AutomationActionTemplateConditionFragment on AutomationActionTemplateCondition {
    id
    description
    expression
  }
  fragment AutomationActionTemplateRequiredContextFragment on AutomationActionTemplateRequiredContext {
    id
    fields
    scope
  }
`
